import { Icon } from "../icon/Icon";

import "./Pill.css";

import type { IconProps } from "../icon/Icon";
import type { ReactNode, SyntheticEvent } from "react";

export interface PillProps {
  children?: ReactNode;
  icon?: IconProps["icon"];
  iconVariant?: IconProps["variant"];
  onClick?: (e: SyntheticEvent) => void;
}

export function Pill({ children, icon, iconVariant, onClick }: PillProps) {
  return (
    <button className="Pill" onClick={onClick}>
      {icon && <Icon icon={icon} variant={iconVariant} size="sm" />}
      {children}
    </button>
  );
}
